(function() {
  'use strict';

  var activeTooltip = null;

  function initValidation(input) {
    if (input.dataset.cfcValidationBound) return;
    input.dataset.cfcValidationBound = '1';

    input.addEventListener('invalid', function(e) {
      e.preventDefault();
      showCustomTooltip(input);
    });

    input.addEventListener('input', function() {
      hideCustomTooltip();
    });
  }

  function showCustomTooltip(input) {
    hideCustomTooltip();

    var tooltip = document.createElement('div');
    tooltip.className = 'cfc-qty-tooltip cfc-qty-tooltip--visible';

    var step = parseInt(input.step, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 999999;

    if (step > 1) {
      tooltip.textContent = 'Quantity must be in increments of ' + step + ' (between ' + min + ' and ' + max.toLocaleString() + ').';
    } else {
      tooltip.textContent = 'Please enter a valid quantity.';
    }

    document.body.appendChild(tooltip);
    activeTooltip = { el: tooltip, input: input };

    positionTooltip();
    setTimeout(hideCustomTooltip, 4000);
  }

  function positionTooltip() {
    if (!activeTooltip) return;
    var rect = activeTooltip.input.getBoundingClientRect();
    var el = activeTooltip.el;
    var tooltipHeight = el.offsetHeight || 40;

    el.style.position = 'fixed';
    el.style.top = (rect.bottom + 10) + 'px';
    el.style.left = (rect.left + rect.width / 2) + 'px';
    el.style.transform = 'translateX(-50%)';
  }

  function hideCustomTooltip() {
    if (activeTooltip && activeTooltip.el.parentNode) {
      activeTooltip.el.parentNode.removeChild(activeTooltip.el);
    }
    activeTooltip = null;
  }

  // Hide on scroll (simpler than repositioning)
  window.addEventListener('scroll', hideCustomTooltip, true);
  window.addEventListener('resize', hideCustomTooltip);

  function bindAll() {
    document.querySelectorAll('.quantity__input').forEach(initValidation);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  var observer = new MutationObserver(function(mutations) {
    var hasNew = mutations.some(function(m) { return m.addedNodes.length > 0; });
    if (hasNew) bindAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
